export default function IconShoppingCart({ color = "white", size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M5 5H8.33333L9 8.33333M11.6667 21.6667H28.3333L35 8.33333H9M11.6667 21.6667L9 8.33333M11.6667 21.6667L7.84518 25.4882C6.79524 26.5381 7.53885 28.3333 9.02369 28.3333H28.3333M28.3333 28.3333C26.4924 28.3333 25 29.8257 25 31.6667C25 33.5076 26.4924 35 28.3333 35C30.1743 35 31.6667 33.5076 31.6667 31.6667C31.6667 29.8257 30.1743 28.3333 28.3333 28.3333ZM15 31.6667C15 33.5076 13.5076 35 11.6667 35C9.82572 35 8.33333 33.5076 8.33333 31.6667C8.33333 29.8257 9.82572 28.3333 11.6667 28.3333C13.5076 28.3333 15 29.8257 15 31.6667Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
